import { inject, Injectable } from '@angular/core';
import { LoginService, VeterinarianSearchService } from '@pxl/models/contracts';
import {
    GetVeterinariansInVicinityModel,
    VeterinarianFeature,
    VeterinarianModel,
    VeterinarianSearchService as VeterinarianSearchBackendService,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultVeterinarianSearchService implements VeterinarianSearchService {
    private readonly loginService = inject(LoginService);
    private readonly veterinarianSearchBackendService = inject(VeterinarianSearchBackendService);
    public getVeterinariansInVicinity(
        latitude: number,
        longitude: number,
        distanceInKilometers: number,
        veterinarianFeature?: VeterinarianFeature | null,
    ): Observable<VeterinarianModel[]> {
        const body: GetVeterinariansInVicinityModel = {
            latitude,
            longitude,
            distanceInKilometers,
            veterinarianFeature,
        };
        return this.veterinarianSearchBackendService.getVeterinariansInVicinity(body, this.loginService.getToken());
    }
}
